import { NotificationType } from "@wingspanhq/wingspan-api-sdk";
import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { selectorActiveNotifications } from "./selectorActiveNotifications";

type NotificationWithGroup = WSNotificationResponse & {
  group: WSNotificationResponse[];
};

export const selectorGroupedTodos = (
  notifications: WSNotificationResponse[]
) => {
  const result: NotificationWithGroup[] = [];

  selectorActiveNotifications(notifications)
    // Todos should *not* include dismissable notifications
    .filter(notification => notification.type !== NotificationType.DISMISSABLE)
    .forEach(notification => {
      if (
        [
          NotificationHandleType.SignatureCollaborator,
          // NotificationHandleType.BackgroundCheckRequestContractor,
          NotificationHandleType.InsuranceCoverageMonitoringContractor,
          NotificationHandleType.FileSharingRequestContractor,
          NotificationHandleType.SignatureClient,
          NotificationHandleType.W9Consent,
          NotificationHandleType.RequirementPendingReviewClient,
          NotificationHandleType.PayoutMethod,
          NotificationHandleType.WorkLogSubmittedForReviewPayer
        ].includes(notification.handle as NotificationHandleType) &&
        result.some(r => r.handle === notification.handle)
      ) {
        result
          .find(r => r.handle === notification.handle)
          ?.group.push(notification);
      } else {
        result.push({ ...notification, group: [notification] });
      }
    });

  return result;
};
